import request from '@/utils/request'
import URL from './urlTranslator'

// V3报表导出
export function v3ReportExport(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.report.v3ReportExport,
    method: 'post',
    data
  })
}
